// extracted by mini-css-extract-plugin
export default {"empty":"Report_empty__VndK2","placeHolderShimmer":"Report_placeHolderShimmer__swmmT"};